import { useEffect, useRef, useState } from "react";

const ScratchCard = ({ text, watchWorthyScore }) => {
    const canvasRef = useRef(null);
    const [scratched, setScratched] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        // Set canvas size
        canvas.width = 50;
        canvas.height = 50;

        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        let colorStart = "";
        let colorStop = "";

        if (watchWorthyScore === 0) {
            colorStart = "rgb(0,102,225)";
            colorStop = "rgb(0,153,255)";
        } else if (watchWorthyScore >= 3 && watchWorthyScore === 1) {
            colorStart = "rgb(255, 170, 0)";
            colorStop = "rgb(255, 102, 0)";
        } else {
            colorStart = "rgb(255, 0, 0)";
            colorStop = "rgb(255, 51, 0)";
        }
        gradient.addColorStop(0, colorStart);
        gradient.addColorStop(1, colorStop);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        let isDrawing = false;

        const getCoordinates = (e) => {
            const rect = canvas.getBoundingClientRect();
            // Handle both mouse and touch events
            if (e.touches && e.touches.length > 0) {
                return {
                    x: e.touches[0].clientX - rect.left,
                    y: e.touches[0].clientY - rect.top
                };
            }
            return {
                x: e.clientX - rect.left,
                y: e.clientY - rect.top
            };
        };

        const startScratch = (e) => {
            e.preventDefault(); // Prevent scrolling on touch
            isDrawing = true;
            scratch(e);
        };

        const endScratch = () => {
            isDrawing = false;
            checkScratchCompletion();
        };

        const scratch = (e) => {
            if (!isDrawing) return;
            e.preventDefault(); // Prevent scrolling on touch
            
            const { x, y } = getCoordinates(e);

            ctx.globalCompositeOperation = "destination-out";
            ctx.beginPath();
            ctx.arc(x, y, 10, 0, Math.PI * 2);
            ctx.fill();
        };

        const checkScratchCompletion = () => {
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const pixels = imageData.data;
            let erasedPixels = 0;

            for (let i = 0; i < pixels.length; i += 4) {
                if (pixels[i + 3] === 0) erasedPixels++;
            }

            const threshold = 0.5 * (canvas.width * canvas.height);
            if (erasedPixels > threshold) {
                setScratched(true);
            }
        };

        canvas.addEventListener("mousedown", startScratch);
        canvas.addEventListener("mousemove", scratch);
        canvas.addEventListener("mouseup", endScratch);
        canvas.addEventListener("mouseleave", endScratch);
        canvas.addEventListener("touchstart", startScratch, { passive: false });
        canvas.addEventListener("touchmove", scratch, { passive: false });
        canvas.addEventListener("touchend", endScratch);

        return () => {
            canvas.removeEventListener("mousedown", startScratch);
            canvas.removeEventListener("mousemove", scratch);
            canvas.removeEventListener("mouseup", endScratch);
            canvas.removeEventListener("mouseleave", endScratch);
            canvas.removeEventListener("touchstart", startScratch);
            canvas.removeEventListener("touchmove", scratch);
            canvas.removeEventListener("touchend", endScratch);
        };
    }, [watchWorthyScore]);

    return (
        <div className="scratch-card">
            <span className={`score ${scratched ? "revealed" : ""}`}>{text}</span>
            {!scratched && <canvas ref={canvasRef} className="scratch-overlay" />}
        </div>
    );
};

export default ScratchCard;